import styled from '@emotion/styled';
import { memo, useMemo } from 'react';
import { useSnapshot } from 'valtio';
import { scrollbar2Css } from '~/css/scrollbarCss';
import { fill_horizontal_all_center, fill_horizontal_cross_center, fill_vertical_cross_center, } from '~/modules/AppLayout/FlexGridCss';
import { SimpleQuoteListInteractWithChart } from '~/modules/symbolQuote/simple';
import { useVirtualAccountOrderPre, useVirtualTransaction, } from '~/modules/virtualExchange/useVirtualExchangeResource';
import { staticStore } from '~/pages/heineken_template/_private/staticStore';
import { wu5868_strategiesDayTradeGroup } from '../wu5868_initStrategies';
import { store } from '~/pages/heineken_template/_private/store';
import dayAPI from '~/utils/dayAPI';
import { css } from '@emotion/react';
import { wu5868_store } from '../wu5868_SidePane2';
export const StockSignal = memo(function StocStockSignalkPopular() {
    const storeState = useSnapshot(wu5868_store);
    const lastTradeDate = useSnapshot(staticStore).tradedDate.day0;
    const intraday = useSnapshot(staticStore).tradedDate.intraday;
    //日線進出場訊號
    const dailyEntryData = useVirtualAccountOrderPre('wu5868_stock_long', 'B');
    const dailyExitData = useVirtualAccountOrderPre('wu5868_stock_long', 'S');
    const dailyEntrySymbol = dailyEntryData?.map(s => s.symbol);
    const dailyExitSymbol = dailyExitData?.map(s => s.symbol);
    const exitDate = dailyExitData?.map(s => s.createdDatetime)[0];
    //分鐘進出場訊號
    const minuteStrategySymbol = useVirtualTransaction('wu5868_minute', {
        beginDatetime: intraday.add(0, 'day').format('YYYY-MM-DD'),
    });
    const minuteEntrySymbol = useMemo(() => {
        return minuteStrategySymbol
            ?.filter(datum => datum.bs === 'B' && datum.positionType === 'O')
            .map(datum => datum.symbol);
    }, [minuteStrategySymbol]);
    const minuteExitSymbol = useMemo(() => {
        return minuteStrategySymbol
            ?.filter(datum => datum.bs === 'S' && datum.positionType === 'C')
            .map(datum => datum.symbol);
    }, [minuteStrategySymbol]);
    //最種要顯示的商品
    const resultEntrySymbol = storeState.signalType === 'daily' ? dailyEntrySymbol : minuteEntrySymbol;
    const resultExitSymbol = storeState.signalType === 'daily' ? dailyExitSymbol : minuteExitSymbol;
    const strategyType = storeState.signalType === 'daily' ? 1 : 2;
    return (<styleds.container>
      <div css={css `
          ${fill_horizontal_all_center};
          height: 28px;
          gap: 4px;
        `}>
        <styleds.strategyButton selected={storeState.signalType === 'daily'} onClick={() => (wu5868_store.signalType = 'daily')}>
          日線訊號
        </styleds.strategyButton>
        <styleds.strategyButton selected={storeState.signalType === 'minute'} onClick={() => (wu5868_store.signalType = 'minute')}>
          5分訊號
        </styleds.strategyButton>
      </div>
      <styleds.title backgroundFill='#ac2222'>
        <span>進場</span>
        <styleds.updateContent>
          {dayAPI(exitDate).add(8, 'hour').format('MM/DD HH:mm')}更新
        </styleds.updateContent>
      </styleds.title>
      <styleds.lsitContent>
        <SimpleQuoteListInteractWithChart data={resultEntrySymbol ?? []} chart={store.charting} handleClick={() => {
            store.charting.setStrategy(wu5868_strategiesDayTradeGroup.main[strategyType]);
            store.charting.changeInterval('D');
            store.charting.updateFromState();
        }}/>
      </styleds.lsitContent>
      <styleds.title backgroundFill='#a3a3a3'>
        <span>出場</span>
        <styleds.updateContent>
          {dayAPI(exitDate).add(8, 'hour').format('MM/DD HH:mm')}更新
        </styleds.updateContent>
      </styleds.title>
      <styleds.lsitContent>
        <SimpleQuoteListInteractWithChart data={resultExitSymbol ?? []} chart={store.charting} handleClick={() => {
            store.charting.setStrategy(wu5868_strategiesDayTradeGroup.main[strategyType]);
            store.charting.changeInterval('D');
            store.charting.updateFromState();
        }}/>
      </styleds.lsitContent>
    </styleds.container>);
});
const styleds = {
    container: styled.div `
    ${fill_vertical_cross_center};
    gap: 2px;
  `,
    headerContent: styled.div `
    width: 100%;
    height: 36px;
  `,
    lsitContent: styled.div `
    ${scrollbar2Css};
    height: calc(50% - 40px);
  `,
    title: styled.div `
    ${fill_horizontal_all_center};
    position: relative;
    height: 32px;
    border-radius: 4px;
    color: #fafafa;
    background-color: ${props => props.backgroundFill};
  `,
    updateContent: styled.span `
    position: absolute;
    ${fill_horizontal_cross_center};
    justify-content: end;
    align-items: end;
    font-size: 12px;
    padding: 0 4px;
    margin-bottom: 4px;
  `,
    strategyButton: styled.div `
    ${fill_horizontal_all_center};
    background-color: ${props => (props.selected ? '#4589df' : '#cecece')};
    color: ${props => (props.selected ? '#ffffff' : '#454545')};
    border-radius: 4px;
    border: 1px solid #cccccc;
    cursor: pointer;
    font-size: 14px;
    font-weight: bold;
  `,
};
